









import { Component, Emit, Vue } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Emit()
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  clicked(e: any) {
    return e.target.value;
  }
}
